import { SxProps, Theme } from "@mui/material/styles";

export function listRequestsWrapper(theme: Theme): SxProps<Theme> {
    return {
        zIndex: 1, 
        width: "100%", 
        borderRadius: "20px", 
        my: "24px", 
        height: "calc(100vh - (84px * 1) - 2px - 48px)", 
        maxHeight: "calc(100vh - (84px * 1) - 2px - 48px)"
    };
}

export function listRequestsTitle(theme: Theme): SxProps<Theme> {
    return {
        margin: 0,
        paddingTop: "0.3em",
        paddingBottom: 0
    };
}

export function titleWrapper(theme: Theme): SxProps<Theme> {
    return {
        width: "100%",
        textAlign: "center",
        backgroundColor: "#ececec"
    };
}


export function tableContainer(theme: Theme): SxProps<Theme> {
    return {
        overflow:"auto",
        maxHeight: "calc(100% - 48px - 0.3em)",
        height: "calc(100% - 48px - 0.3em)"
    };
}


export function tableSearch(theme: Theme): SxProps<Theme> {
    return {
        display: "flex",
        alignContent: "center",
        justifyContent: "center"
    };
}


export function tableTextField(theme: Theme): SxProps<Theme> {
    return {
        maxWidth: "150px",
        backgroundColor:"white",
        borderRadius: "5px"
    };
}

export function dateTextField(theme: Theme): SxProps<Theme> {
    return {
        backgroundColor:"white",
        borderRadius: "5px"
    }
}

export function tableHeaderCell(theme: Theme): SxProps<Theme> {
    return {
        backgroundColor: "#ececec",
    };
}

export function tableCell(theme: Theme): SxProps<Theme> {
    return {
        textAlign: "center"
    };
}

export function tableFooter(theme: Theme): SxProps<Theme> {
    return {
        backgroundColor: "#ececec"
    };
}

export function statusFilter(theme: Theme): SxProps<Theme> {
    return {
        maxWidth: "125px",
        width: "125px",
        backgroundColor:"white",
        borderRadius: "5px"
    };
}

export function button(theme: Theme): SxProps<Theme> {
    return {
    }
}

export function dataField(theme: Theme): SxProps<Theme> {
    return {
        textAlign: 'center',
        alignContent: 'center',
        justifyContent: 'center',
        paddingTop: '1.25rem'
    }
}

export function locationBox(theme: Theme): SxProps<Theme> {
    return {
        paddingBottom: '0.50rem'
    }
}

export function datePicker(theme: Theme): SxProps<Theme> {
    return {
        marginRight: '200px'
    }
}

export function errorBox(theme: Theme): SxProps<Theme> {
    return {
        color: 'red',
        paddingTop: '0.50rem'
    }
}

export function form(theme: Theme): SxProps<Theme> {
    return {
        width: '18rem',
        paddingBottom: '0.50rem'
    }
}